import { Link } from "react-router-dom";

export default function HomeCta() {
  return (
    <section className="w-full px-4 py-14 md:px-6 md:py-20" aria-label="行动号召">
      <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-12 md:px-14 md:py-16">
        <div
          className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-accent-400/40"
          aria-hidden="true"
        />
        <div
          className="pointer-events-none absolute -bottom-20 left-1/3 h-48 w-48 rounded-full bg-primary-700/50"
          aria-hidden="true"
        />
        <div className="relative z-10 flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h2 className="font-heading text-3xl leading-snug text-background-50 md:text-4xl">
              不想错过每天的瓜？
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
              进入合集列表页，用分类和关键词快速找到你关心的内容；有想看的选题，也欢迎直接告诉我们。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/gossip"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-label text-primary-700 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-compass-3-line" aria-hidden="true" />
              浏览吃瓜合集
            </Link>
            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-100/50 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-send-plane-line" aria-hidden="true" />
              提交选题建议
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}